import {
    KeywordResearchCategoriesPaginatedResponse,
    KeywordResearchPaginatedResponse,
} from 'api/Banner/sovSearchResultsApi'
import { BannerRequestBody } from 'api/Banner/types'
import { getCerebroHeaders } from 'api/Cerebro/headers'
import {
    CerebroApiOptions,
    CerebroPaginatedResponse,
    CerebroResourceResponse,
} from 'api/Cerebro/types'
import { orgScopedApiClient } from 'api/orgScopedClient'
import { Report, SovKeywordSearchVolume } from 'types'
export const getSovKeywordsForAsin = (
    params: BannerRequestBody,
    options: CerebroApiOptions = {}
): Promise<KeywordResearchPaginatedResponse> =>
    orgScopedApiClient.post(
        `/api/sov_keyword_research/asin/aggregate/banner/`,
        params,
        {
            headers: getCerebroHeaders(options.headers),
        }
    )

export const getSovKeywordsForAsinAsyncExport = (
    params: BannerRequestBody
): Promise<CerebroResourceResponse<Report>> =>
    orgScopedApiClient.post(
        '/api/sov_keyword_research/asin/aggregate/banner/export/',
        params
    )

export const getSovKeywordsForKeyword = (
    params: BannerRequestBody,
    options: CerebroApiOptions = {}
): Promise<KeywordResearchPaginatedResponse> =>
    orgScopedApiClient.post(
        `/api/sov_keyword_research/keyword/aggregate/banner/`,
        params,
        {
            headers: getCerebroHeaders(options.headers),
            signal: options.signal,
        }
    )

export const getSovKeywordsForKeywordAsyncExport = (
    params: BannerRequestBody
): Promise<CerebroResourceResponse<Report>> =>
    orgScopedApiClient.post(
        '/api/sov_keyword_research/keyword/aggregate/banner/export/',
        params
    )

export const getSovKeywordSearchVolume = (
    params: BannerRequestBody,
    options: CerebroApiOptions = {}
): Promise<CerebroPaginatedResponse<SovKeywordSearchVolume>> =>
    orgScopedApiClient.post(
        '/api/keyword_research_search_volume_facts/aggregate/banner/',
        params,
        {
            headers: getCerebroHeaders(options.headers),
        }
    )

export const getSovKeywordsCategoriesForAsin = (
    params: BannerRequestBody,
    options: CerebroApiOptions = {}
): Promise<KeywordResearchCategoriesPaginatedResponse> =>
    orgScopedApiClient.post(
        `/api/sov_keyword_research_categories/asin/aggregate/banner/`,
        params,
        {
            headers: getCerebroHeaders(options.headers),
        }
    )

export const getSovKeywordsCategoriesForKeyword = (
    params: BannerRequestBody,
    options: CerebroApiOptions = {}
): Promise<KeywordResearchCategoriesPaginatedResponse> =>
    orgScopedApiClient.post(
        `/api/sov_keyword_research_categories/keyword/aggregate/banner/`,
        params,
        {
            headers: getCerebroHeaders(options.headers),
            signal: options.signal,
        }
    )

export const getSovKeywordsForSegment = (
    params: BannerRequestBody,
    options: CerebroApiOptions = {}
): Promise<KeywordResearchPaginatedResponse> =>
    orgScopedApiClient.post(
        `/api/sov_keyword_research/segment/aggregate/banner/`,
        params,
        {
            headers: getCerebroHeaders(options.headers),
        }
    )

export const getSovKeywordsForSegmentAsyncExport = (
    params: BannerRequestBody
): Promise<CerebroResourceResponse<Report>> =>
    orgScopedApiClient.post(
        '/api/sov_keyword_research/segment/aggregate/banner/export/',
        params
    )

export const getSovKeywordsCategoriesForSegment = (
    params: BannerRequestBody,
    options: CerebroApiOptions = {}
): Promise<KeywordResearchCategoriesPaginatedResponse> =>
    orgScopedApiClient.post(
        `/api/sov_keyword_research_categories/segment/aggregate/banner/`,
        params,
        {
            headers: getCerebroHeaders(options.headers),
        }
    )
